import appLayout from '../layouts/AppLayout.vue'
export default [
  {
    path: '/hotels/search/ratehawk',
    name: 'hotels-ratehawk',
    component: () => import(/* webpackChunkName: "hotels-ratehawk" */ '../views/hotels/ratehawk/index.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/hotels/options/ratehawk',
    name: 'hotels-options-ratehawk',
    component: () => import(/* webpackChunkName: "hotels-ratehawk" */ '../views/hotels/ratehawk/hotelOptions.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/hotels/reserve/ratehawk',
    name: 'hotels-reserve-ratehawk',
    component: () => import(/* webpackChunkName: "hotels-ratehawk" */ '../views/hotels/ratehawk/reserve.vue'),
    meta: { layout: appLayout }
  }
]
